import * as XLSX from "xlsx";

interface Column {
  label: string;
  key?: string;
}

const s2ab = (s: string): ArrayBuffer => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};

const generateExcelFile = async (
  data: Array<any>,
  filename: string,
  sheetName: string,
  columns: Array<Column>
): Promise<void> => {
  const exportToExcel = () => {
    if (data) {
      const customizedData = data.map((item) => {
        const rowData: Record<string, any> = {};
        columns.forEach((column) => {
          rowData[column.label] = column.key ? item[column.key] : "";
        });
        return rowData;
      });

      const ws = XLSX.utils.json_to_sheet(customizedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      const arrayBuffer = s2ab(wbout);
      const wbBlob = new Blob([arrayBuffer], {
        type: "application/octet-stream",
      });
      const wbUrl = URL.createObjectURL(wbBlob);

      const anchor = document.createElement("a");
      anchor.href = wbUrl;
      anchor.download = `${filename}.xlsx`;
      anchor.dispatchEvent(new MouseEvent("click"));

      URL.revokeObjectURL(wbUrl);
    }

  };

  exportToExcel();
};

const generateExcelFileWithMultipleSheets = async (
  excelDatas: Array<any>,
  filename: string
): Promise<void> => {
  if (!excelDatas || excelDatas.length === 0) return;

  const wb = XLSX.utils.book_new();

  excelDatas.forEach((sheetItem) => {
    const { sheetName, excelColumnData, excelData } = sheetItem;

    // Map data according to column keys
    const formattedData = excelData.map((row: any) => {
      const newRow: Record<string, any> = {};
      excelColumnData.forEach((col: any) => {
        if (col.isView) {
          newRow[col.label] = row[col.key] ?? "";
        }
      });
      return newRow;
    });

    const ws = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(wb, ws, sheetName || "Sheet1");
  });

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
  const arrayBuffer = s2ab(wbout);
  const blob = new Blob([arrayBuffer], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${filename}.xlsx`;
  anchor.click();

  URL.revokeObjectURL(url);
};

export  {generateExcelFile, generateExcelFileWithMultipleSheets};
